export const CROSS_SELLING_RANKING_ENDPOINT =
	"/transactional/cross-selling/ranking"
